type CallbackFunction = (() => void | Promise<void>) | ((start_timestamp: number) => void | Promise<void>);

export class DocumentVisibilityTracker {
  private readonly INTERVAL_DURATION = 1000;

  // 누적 시간
  private accumulated_time = 0;

  // 최대 시간
  private readonly max_time_ms: number;

  // `max_time_ms` 채우면 실행할 콜백
  private readonly callback: CallbackFunction;

  private readonly visibility_handler: () => void;

  // 타이머 시작한 시간 (최근 값)
  private start_timestamp = 0;

  private timer: ReturnType<typeof setInterval> | null = null;

  constructor(max_time_ms: number, callback: CallbackFunction) {
    this.max_time_ms = max_time_ms;
    this.callback = callback;
    this.visibility_handler = this.handleVisibilityChange.bind(this);
  }

  public startTracking() {
    // 핸들러 최초 실행
    this.visibility_handler();

    document.addEventListener('visibilitychange', this.visibility_handler);
  }

  public stopTracking() {
    document.removeEventListener('visibilitychange', this.visibility_handler);
  }

  // 페이지 가시성 상태 변경 시 처리
  private handleVisibilityChange() {
    if (document.hidden) {
      this.pauseTimer();
    } else {
      this.startTimer();
    }
  }

  private startTimer() {
    if (this.timer) {
      return;
    }

    this.start_timestamp = Date.now(); // 타이머 시작 시간을 기록
    this.timer = setInterval(() => {
      this.incrementAccumulatedTime();

      // 누적 시간에 도달하면 callback 호출하고 누적시간 리셋
      if (this.accumulated_time >= this.max_time_ms) {
        this.callback(this.start_timestamp);
        this.resetAccumulatedTime();
      }
    }, this.INTERVAL_DURATION);
  }

  private pauseTimer() {
    this.clearTimer();
    this.addDiffToAccumulatedTime();
  }

  private clearTimer() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  private incrementAccumulatedTime() {
    this.accumulated_time += this.INTERVAL_DURATION;
  }

  private addDiffToAccumulatedTime() {
    // 마지막 시간을 더해서 누적 시간에 반영
    this.accumulated_time += Date.now() - this.start_timestamp;
  }

  private resetAccumulatedTime() {
    this.accumulated_time = 0;
    this.start_timestamp = Date.now();
  }
}
